import zoho from '../assets/integrations/zoho.svg';
import docusign from '../assets/integrations/docusign.svg';
import linkedin from '../assets/integrations/linkedin.svg';
import zohosign from '../assets/integrations/zohosign.png';
import apollo from '../assets/integrations/apollo.png';
import otx from '../assets/integrations/alienvault-otx.svg';

/**
 * Genuine brand marks committed under src/assets/integrations (never fetched at runtime):
 *   zoho.svg     - simple-icons "Zoho" (CC0), the Zoho parent mark (kept for generic Zoho use).
 *   zohosign.png - Zoho Sign product icon, cropped from zoho.com/sign og:image (trademark of Zoho Corp.).
 *   apollo.png   - Apollo.io app icon, apple-touch-icon from apollo.io (trademark of Apollo.io, Inc.).
 *   alienvault-otx.svg - OTX logo from otx.alienvault.com/assets/images/otx-logo.svg, white fill recoloured #232345 for the light tile (trademark of AT&T/LevelBlue).
 *   linkedin.svg - Wikimedia Commons "LinkedIn icon.svg" (public domain, trademarked).
 *   docusign.svg - Wikimedia Commons "DocuSign Logo.svg" (public domain, trademarked).
 * Any provider NOT listed here (Pathkey: vendor not yet confirmed, see backoffice-ticketing-pathkey-sqa.md) is rendered as a neutral lettermark tile by
 * `LogoTile`: we have no licensed asset for them and never draw a look-alike. Drop a file here and add it below
 * to replace a lettermark. Keys are upper-cased provider ids / card keys.
 */
export const BRAND_LOGOS = Object.freeze({
    ZOHOSIGN: zohosign,
    ZOHO_SIGN: zohosign,
    APOLLO_ENRICHMENT: apollo,
    APOLLO: apollo,
    ALIENVAULT_OTX: otx,
    DOCUSIGN: docusign,
    LINKEDIN: linkedin,
});

export const logoFor = (key) => BRAND_LOGOS[String(key || '').toUpperCase()] || null;
